export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14899.60d55f94.jpg";